/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

import UiFormLabel from 'components/Ui/UiFormLabel'

type FormFieldProps = {
    label?: React.ReactNode
    description?: React.ReactNode
    error?: React.ReactNode
    children: React.ReactNode
    className?: string
    required?: boolean
}

const UiFormField: React.FC<FormFieldProps> = ({
    label,
    description,
    error,
    children,
    className,
    required,
}) => {
    return (
        <div className={clsx('UiFormField', className)}>
            {label && (
                <UiFormLabel isRequired={required} className="mb-1">
                    {label}
                </UiFormLabel>
            )}
            {description && (
                <div
                    className={clsx(
                        'mb-1 text-xs text-gray-500 dark:text-gray-400'
                    )}
                >
                    {description}
                </div>
            )}
            {children}
            {error && (
                <div
                    className={clsx(
                        'mt-1 text-xs text-red-600 dark:text-red-400'
                    )}
                >
                    {error}
                </div>
            )}
        </div>
    )
}

export default UiFormField
